import { render, staticRenderFns } from "./ClientHedgingReport.vue?vue&type=template&id=41f930c7"
import script from "./ClientHedgingReport.vue?vue&type=script&lang=js"
export * from "./ClientHedgingReport.vue?vue&type=script&lang=js"
import style0 from "./ClientHedgingReport.vue?vue&type=style&index=0&id=41f930c7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports